import { Title, Button } from "@vshp/ui-components";
import teachersBg from "../../../public/images/teachers.jpg";

import teacher03 from "../../../public/images/teachers/teacher03.jpg";
import teacher07 from "../../../public/images/teachers/teacher07.jpg";
import teacher08 from "../../../public/images/teachers/teacher08.jpg";
import teacher09 from "../../../public/images/teachers/teacher09.jpg";
import teacher10 from "../../../public/images/teachers/teacher10.jpg";
import teacher12 from "../../../public/images/teachers/teacher12.jpg";
import teacher13 from "../../../public/images/teachers/teacher13.jpg";
import Slider from "../utils/Slider";
import Image from "next/image";
import { URL } from "../../config/config";

const teachers = [
  {
    photo: teacher03,
    name: "Казначеева Мария Михайловна",
    position: "Учитель истории и обществознания.",
    description: `Педагогический стаж работы: 27 лет.<br />
    Награждена почетной грамотой  Министерства образования.`,
  },
  {
    photo: teacher13,
    name: "Малышев Павел Сергеевич",
    position: "Учитель Физической культуры, ОБЖ",
    description: `Диплом о профессиональной переподготовке ЧУВО «ВШП» «Педагогика и психология образования» 2017 г. Повышение квалификации ЧУВО «ВШП» «Теория и методика преподавания информатики в условиях реализации ФГОС» 2020 г. Повышение квалификации ЧУВО «ВШП» «Оказание первой помощи в образовательной организации» 2019 г.
      <br />
      ГГОУ ВПО «Тверской государственный университет»`,
  },
  {
    photo: teacher07,
    name: "Суслов Степан Николаевич",
    position: "Учитель математики, педагог-организатор",
    description: `Окончил математический факультет ТвГУ по&nbsp;специальности &laquo;Компьютерная безопасность&raquo;. Имеет опыт работы 3-4 года в&nbsp;муниципальных школах, а&nbsp;также 6&nbsp;лет&nbsp;&mdash; в&nbsp;сфере детского отдыха: работал в&nbsp;МДЦ &laquo;КОМПЬЮТЕРиЯ&raquo; на&nbsp;всех позициях&nbsp;&mdash; от&nbsp;вожатого до&nbsp;заместителя руководителя смены, в&nbsp;том числе на&nbsp;международных сменах.`,
  },
  {
    photo: teacher08,
    name: "Копнин Алексей Сергеевич",
    position: "Учитель математики и физики",
    description: `Окончил физический факультет МГУ имени М.В. Ломоносова по&nbsp;специальности &laquo;Физик&raquo;. Имеет диплом &laquo;Московской академии профессиональных компетенций&raquo; о&nbsp;профессиональной переподготовке и&nbsp;присвоении квалификации &laquo;Учитель математики и&nbsp;физики&raquo;. Занимается подготовкой к&nbsp;сдаче ОГЭ, ЕГЭ и&nbsp;вступительным испытаниям в&nbsp;вуз. Педагогический стаж: 15&nbsp;лет.`,
  },
  {
    photo: teacher09,
    name: "Шеньков Никита Сергеевич",
    position: "Учитель иностранного языка (английский)",
    description: `Имеет диплом с&nbsp;отличием по&nbsp;направлению &laquo;Теория и&nbsp;методика преподавания иностранных языков&raquo;, сертификаты организатора ЕГЭ и&nbsp;ОГЭ, по&nbsp;работе с&nbsp;ФГОС, о&nbsp;прохождении ТКТ. Сопровождал туристов из&nbsp;Америки, Канады и&nbsp;Франции на&nbsp;экскурсиях. Проходил курсы повышения квалификации на&nbsp;базе РЦОИ. Педагогический стаж: 10&nbsp;лет.`,
  },
  {
    photo: teacher10,
    name: "Голубев Павел Валентинович",
    position: "Учитель истории и обществознания",
    description:
      "Окончил Тверской государственный университет (ТвГУ) по&nbsp;направлению &laquo;История&raquo;. Защитил диплом отделения дополнительных профессий при ТвГУ. Присвоена дополнительная профессия&nbsp;&mdash; референт-переводчик с&nbsp;английского языка. Имеет первую квалификационную категорию. Педагогический стаж: 9&nbsp;лет.",
  },
  {
    photo: teacher12,
    name: "Делакова Арина Андреевна",
    position: "Методист",
    description:
      "Награждена грамотой от&nbsp;Управления образования Администрации г. Твери за&nbsp;участие в&nbsp;профессиональных конкурсах педагогического мастерства и&nbsp;значительные успехи в&nbsp;организации учебного и&nbsp;воспитательного процессов. Занимается подготовкой победителей муниципальных, региональных конкурсов и&nbsp;олимпиад. Педагогический стаж: 11&nbsp;лет.",
  },
];

function Teachers() {
  const settings = {
    infinite: true,
  };

  return (
    <section className="page__block page__block_cover">
      <Image className="page__block-img" src={teachersBg} alt="Преподаватели" placeholder="blur" />
      <div className="page__block-body">
        <Title type="h2" decor={false}>
          Учителя
        </Title>

        <Slider className="slider-description" sliderSettings={settings}>
          {teachers.map((teacher, key) => (
            <div className="slider__item" key={key}>
              <div className="slider-description__item teachers-slider__item">
                <div className="slider-description__header teachers-slider__header">
                  <Image className="slider-description__photo teachers-slider__photo" src={teacher.photo} alt={teacher.name} placeholder="blur" />
                  <div className="slider-description__name teachers-slider__name">{teacher.name}</div>
                  <div className="slider-description__post teachers-slider__post" dangerouslySetInnerHTML={{ __html: teacher.position }}></div>
                </div>
                <div className="slider-description__content teachers-slider__content" dangerouslySetInnerHTML={{ __html: teacher.description }}></div>
              </div>
            </div>
          ))}
        </Slider>
        <div className="text-center">
          <Button spaceTop={true} href={`${URL}/teachers`} target="_blank" rel="noopener noreferrer">
            Узнать больше преподавателей
          </Button>
        </div>
      </div>
    </section>
  );
}

export default Teachers;
